<template>
  <svg
    width="44"
    height="44"
    viewBox="0 0 44 44"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="21.9658" cy="21.7122" r="21.7122" fill="#FFC700" />
    <path
      d="M31.9896 20L13 20"
      stroke="white"
      stroke-width="4"
      stroke-linecap="round"
    />
  </svg>
</template>

<script>
export default {
  name: "SkipRounded",
};
</script>
